export default __webpack_public_path__ + "static/media/Chem.b1722995.JPG";